export default "__VITE_ASSET__BX9PvXB5__"